import axios from 'axios';

export const getAllLocations= async () => {
    const url = `/api/v1/user_profile/locations`;
    const res = await axios.get(url);
    return res.data;
};